module.exports = __webpack_public_path__ + "static/feedly_logo-8143f4646197ab4be71ee9a6c35af5f7.png";